// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4645ab78","495":"0b8849f0","496":"ae40edef","842":"ecfc4f80"}[chunkId] + ".chunk.js";
};